<template>
  <div>
    <wordpress-loader :loading="loading" />
    <live-campaign
        v-if="!loading && !error.show"
        :campaign="campaign"
    ></live-campaign>
    <live-error
        v-if="error.show"
    ></live-error>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import WordpressLoader from "@/components/Wordpress/Loader";
import WordpressError from "@/components/Wordpress/Error";
import LiveCampaign from "@/components/Live/Campaign";
import LiveError from "@/components/Live/Error";

export default {
  data() {
    return {
      error: {
        show: false,
        message: '',
      },
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      campaign: 'liveCampaign'
    })
  },
  components: {
    WordpressLoader,
    WordpressError,
    LiveCampaign,
    LiveError
  },
  created() {
    this.loadCampaign();
  },
  methods: {
    loadCampaign() {
      this.$hget('basic/published-ls-campaigns', {
        params: {
          profile_url: this.$route.params.profile_url,
          page_url: this.$route.params.page_url,
        }
      }).then((response) => {
        this.loading = false;
        if(response.data.data)
        {
          this.error.show = false;
          this.error.message = '';
          let campaign = response.data.data.campaign;
          campaign.id = this.$route.query.cid
          this.$store.commit('setLiveCampaign', campaign);
        }
        else
        {
          this.error.show = true;
          this.error.message = "Error Loading campaign, please contact leadslide support";
        }
      }).catch((error) => {
        this.loading = false;
        this.error.show = true;
        this.error.message = 'Error Loading campaign, please contact leadslide support';
      })
    }
  }
}
</script>